import {create} from "zustand";

const useChartStockCode = create((set) => ({
  stockCode: null,
  stockPrice: 0,
  setStockCode: (stockCode: string) => set({ stockCode }),
  setStockCodeAndPrice: ({code, price}: {
    code: string,
    price: number | string
  }) => {
    if (typeof price !== 'number') {
      price = Number(price.replace(/[^0-9]/g, '')) // 숫자만 추출
      price = price || 0
    }
    set({ stockCode: code, stockPrice: price })
  },
}));

export {
  useChartStockCode,
}
